import React from 'react';
import { useSelector } from 'react-redux'
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Drawer } from '@material-ui/core';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import WhatshotIcon from '@material-ui/icons/Whatshot';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import { SidebarNav } from './components';
import { currentUserSelector } from "store/current_user"
import { hasPageAccessPermission } from 'utils/pageAccessPermissionChecker'

const useStyles = makeStyles((theme) => ({
  drawer: {
    width: 150,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)',
    },
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(1),
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  nav: {
    marginBottom: theme.spacing(2),
  },
}));

const Sidebar = (props) => {
  const { open, variant, onClose, className, ...rest } = props;
  const currentUser = useSelector(currentUserSelector)
  const classes = useStyles();
  const accessablePages = [
    {
      title: '自動車',
      href: '/search/car',
      icon: <DirectionsCarIcon />,
      subMenu: [
        {
          title:'車両入替...',
          href:'/search/car?filterBy=replacementOfVehicles',
          toolTipText: '車両入替+その他変更（すべて）'
        },
        {
          title:'年齢・限定...',
          href:'/search/car?filterBy=age',
          toolTipText: '年齢・限定変更+その他変更（車両入替除く）'
        },
        {
          title:'使用目的...',
          href:'/search/car?filterBy=purpose',
          toolTipText: '使用目的+その他非金銭'
        },
        {
          title:'口座（ネ...',
          href:'/search/car?filterBy=netAccount',
          toolTipText: '口座（ネット）'
        }
      ]
    },
    {
      title: '火災・傷害',
      href: '/search/fire-and-injury',
      icon: <WhatshotIcon />,
      subMenu: [
        {
          title:'口座（ネ...',
          href:'/search/fire-and-injury?filterBy=netAccount',
          toolTipText: '口座（ネット）'
        }
      ]
    },
    {
      title: 'ユーザー管理',
      href: '/user/list',
      icon: <PeopleAltIcon />,
    },
  ].filter(page => hasPageAccessPermission({
    path: page.href,
    groups: currentUser?.groupName ?? []
  }))

  return (
    <Drawer
      anchor='left'
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div {...rest} className={clsx(classes.root, className)}>
        <SidebarNav className={classes.nav} pages={accessablePages} />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
};

export default Sidebar;
